import { render } from "./RegisterPhoneVerification.vue?vue&type=template&id=7b99f623"
import script from "./RegisterPhoneVerification.vue?vue&type=script&lang=js"
export * from "./RegisterPhoneVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__